<div class="select-sub-select-container">
  <div class="flex flex-row gap-4 checkbox-container">
    @if (configJson().inputs && configJson().inputs.length > 0) {
      @for (input of configJson().inputs; track input.id ?? $index) {
        @if (input.inputType === 'checkbox') {
          <div class="inner-container">
            @if (isEditButton()) {
              <div class="edit" [class.nav-error]="!inputNavigationInvalid()[$index]">
                @if (!inputNavigationInvalid()[$index]) {
                  <mat-error>Needs a nav target</mat-error>
                }
                <button class="mat-icon-button select-icon-button" disableRipple="true" mat-button [attr.data-qa]="'edit-select-button' + $index"
                        [attr.id]="'edit-button-' + $index" [class.active]="input.selected"
                        (click)="onEditSelect($index)">
                  <i class="fa-regular fa-pen-to-square"></i>
                </button>
              </div>
            }
            <div class="tall-square-checkbox outline" [class.pointers]="allowPointerEvents()">
              <div class="icon-wrapper">
                @if (input.icon) {
                  <lib-svg-icon [svgName]="input.icon"></lib-svg-icon>
                }
              </div>
              <p class="flex justify-content-center">{{ input.label }}</p>
              <div class="flex justify-content-center checkbox-wrapper">
                <mat-checkbox class="select-checkbox" [attr.data-qa]="'select-checkbox-' + $index"
                              [attr.id]="'select-checkbox-' + $index" [name]="'select-checkbox-' + $index" (change)="checkboxClick(input)"
                              [(ngModel)]="input.selected"></mat-checkbox>
              </div>
            </div>
          </div>
        }
      }
    }
  </div>

  @if (showSubSelectTitle()) {
    <h5 class="sub_select_title">{{ configJson().subHeader }}</h5>
  }

  @for (input of configJson().inputs; track input.id ?? $index;) {
    @if (input.options && input.options.length > 0) {
      @if (input.selected) {
        <div class="flex flex-column align-items-center sub_select_container" [class.edit-select]="isEditButton()" [class.select]="!isEditButton()">
          <h5 class="sub_select_label">{{ input.label }}</h5>
          <span class="sub_select_sublabel">{{ input.instructions }}</span>
          <div class="flex flex-wrap justify-content-start gap-4 button-wrapper">
            @for (option of input.options; track j; let j = $index;) {
              @if (isEditButton()) {
                <button class="select-remove-button" disableRipple="true" mat-stroked-button [attr.data-qa]="'remove-select-button' + j"
                        [attr.id]="'remove-button-' + j" [disabled]="input.options.length === 1" (click)="removeButton(j)">
                  <span>{{option.label}}</span>
                  <span><i class="fa-solid fa-x font-bold"></i></span>
                </button>
              } @else {
                <button class="select-remove-button" disableRipple="true" mat-stroked-button [attr.data-qa]="'select-button' + $index"
                        [attr.id]="'select-button-' + $index" [class.selected]="option.selected"
                        (click)="subSelectButtonClicked(option, input.id!, configJson().id!)">
                  <span>{{option.label}}</span>
                </button>
              }
            }
          </div>
        </div>
      }
    }
  }
</div>
